import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ActivitiesService} from '../services';
import {IOption, SnackbarService} from '@shared';
import {
  ActivitiesActionTypes,
  getActivities,
  getActivitiesFailure,
  getActivitiesSuccess,
  setLanguage
} from '../actions';
import {catchError, map, mergeMap, of, tap, withLatestFrom} from 'rxjs';
import {IRootState, selectLanguage} from "@app/store";
import {Store} from "@ngrx/store";

@Injectable()
export class ActivitiesEffects {
  constructor(
    private _actions$: Actions,
    private _activitiesService: ActivitiesService,
    private _snackbarService: SnackbarService,
    private _store: Store<IRootState>
  ) {
  }

  getActivities$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ActivitiesActionTypes.GET_ACTIVITIES),
      mergeMap(() => {
          return this._activitiesService.getActivities().pipe(
            map((activities: IOption[]) => getActivitiesSuccess({activities})),
            catchError(() => {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
              return of(getActivitiesFailure());
            }),
          )
        }
      ),
    ),
  );

  updateActivitiesOnLanguageChange$ = createEffect(() =>
    this._actions$.pipe(
      ofType(setLanguage),
      withLatestFrom(this._store.select(selectLanguage)),
      mergeMap(() => of(getActivities()))
    )
  );
}
